Ext.define('SA.view.TableRowRegion', {
    constructor({rowId, top, bottom}) {
        this.rowId = rowId;
        this.top = top;
        this.bottom = bottom;
    },

    getBottom() {
        return this.bottom;
    },

    getRowId() {
        return this.rowId;
    },

    getTop() {
        return this.top;
    },

    intersectsRegion(region) {
        return this.getBottom() >= region.getTop() && this.getTop() <= region.getBottom();
    }
});